import { FC } from 'react';
import { TColoredText } from 'mir-utils/time/types';
import { getMessageAndColorForExpirationTime } from '../../time/date-formatter';
import { useTranslation } from '../../i18n';
import { useTime } from '../../providers';
import { LabelTypography } from '../LabelTypography';
/**
 * @summary Компонент, который выводит дату в контексте информации о каком-либо модуле в UTM
 * (применяется в Лицензии).
 *
 * @param available - Доступен ли модуль пользователю.
 * @param date - Время в формате Unix timestamp.
 *
 * @description Все свойства влияют на внешний вид сообщения:
 *
 *   Если модуль не доступен или по какой-то причине date пришла в виде null, то
 * будет написано, что модуль отсутствует, а окрашено сообщение будет в чёрный цвет
 * (onSurfaceMainContent).
 *
 */

export const ModuleDateLabel: FC<{
  date: Date;
  available: boolean;
  hideRelative?: boolean;
}> = ({ date, available, hideRelative }) => {
  const { t } = useTranslation();
  const serverTime = useTime();

  const getDateTextAndColor = (): [string, TColoredText] => {
    const missing = !available || date === null;

    if (missing) {
      return [t('abscent'), 'error'];
    }

    const [text, color]: readonly [string, TColoredText] = getMessageAndColorForExpirationTime({
      date,
      now: serverTime,
      hideRelative,
    });

    return [text, color];
  };

  const [text, color]: [string, TColoredText] = getDateTextAndColor();

  return <LabelTypography text={text} type={color} />;
};
